module.exports = __webpack_public_path__ + "img/C10-morocco.06c2200f.png";